import { useState } from 'react';

export function useSelectionMode() {
  const [isSelecting, setIsSelecting] = useState(false);
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  const enter = (seedId?: string) => {
    setIsSelecting(true);
    setSelectedIds(seedId === undefined ? new Set() : new Set([seedId]));
  };

  const exit = () => {
    setIsSelecting(false);
    setSelectedIds(new Set());
  };

  const toggle = (id: string) => {
    setSelectedIds(previous => {
      const next = new Set(previous);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  return { isSelecting, selectedIds, enter, exit, toggle };
}
